import { CommonMutationCrumbs } from './breadcrumb';

export const SearchPersonCancelMarriageCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Cessazione Matrimonio',
    path: '/mutazioni/persona/matrimonio-annullamento',
  },
];

export const CancelMarriageCrumbs = [
  ...SearchPersonCancelMarriageCrumbs,
  {
    name: 'Cessazione Matrimonio',
    path: '/mutazioni/persona/matrimonio-annullamento/annullamento',
  },
];
